import * as React from 'react'
import { cn } from '../../lib/utils'

const VisuallyHidden = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
  ({ ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn('absolute left-[-10000px] top-auto w-[1px] h-[1px] overflow-hidden')}
        {...props}
      />
    )
  }
)
VisuallyHidden.displayName = 'VisuallyHidden'

export { VisuallyHidden }
